  import React, { useEffect, useRef, useState } from "react";
  import AOS from "aos";
  import "aos/dist/aos.css";
  import "../styles/HomePage.css"; // CSS for styling
  import Header from "../components/Header";
  import AboutImage from "../images/AboutUs.jpg";
  import offerImage from "../images/Offerings.jpg";
  import Image1 from "../images/Image1.jpg";
  import Footer from "../components/Footer";
  import WhatsAppButton from "../components/WhatsAppButton";
  import CryptoJS from "crypto-js";
  // Images for the horizontal scroll
  import googleplayimg from "../images/google-play-badge.png";
  import ScrollImage1 from "../images/ScrollImage1.jpg";
  import ScrollImage2 from "../images/ScrollImage2.jpg";
  import ScrollImage3 from "../images/ScrollImage3.jpg";
  import ScrollImage4 from "../images/ScrollImage4.jpg";
  import ScrollImage5 from "../images/ScrollImage5.jpg";
  import giftimg from "../images/gift.png";
  import otpimg from "../images/otp.png";
  import rewardimg from "../images/reward_point.png";
  import dashboardimg from "../images/dashboard.png";
  import smsimg from "../images/sms.jpg";
  import axios from "axios";
  import qs from "qs";

  const HomePage = () => {
  
    const scrollImages = [ScrollImage1, ScrollImage2, ScrollImage3, ScrollImage4, ScrollImage5];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [allPlans, setAllPlans] = useState([]);
  const [expandedPlans, setExpandedPlans] = useState([]);

  const [filteredPlans, setFilteredPlans] = useState([]);
  const [duration, setDuration] = useState(365);
  const [roCount, setRoCount] = useState(1);
  const [planPrice, setPlanPrice] = useState(null);


  const API_BASE_URL = "https://api.drivergems.com";

  function generateSignature(method, urlPath, timestamp) {
      const secretKey = "jnpkXDAM1GBvyDxYITtukz43zekx6UXgpipODwW9KY5";
      const message = `${method}${urlPath}${timestamp}`;
      return CryptoJS.HmacSHA256(message, secretKey).toString(CryptoJS.enc.Hex);
  }
    useEffect(() => {
      // Initialize AOS
      AOS.init({ duration: 800, once: false });
      AOS.refresh();
    const hash = window.location.hash;
  if (window.location.hash === "#subscription-plans") {
    setTimeout(() => {
      const section = document.getElementById("subscription-plans");
      const headerOffset = 120; // ✅ Adjust this value if needed
      const elementPosition = section.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }, 300);
  }
      const interval = setInterval(() => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % scrollImages.length);
      }, 2000); // Change every 3 seconds
    
      return () => clearInterval(interval);


      
    }, []);
    
    // Fetch price from API whenever dropdown values change
  useEffect(() => {
  const fetchPlans  = async () => {
  try {



  const method = "GET";
          const urlPath = "/v1/openapi/subscriptionplans";
          const timestamp = Math.floor(Date.now() / 1000).toString();
          const signature = generateSignature(method, urlPath, timestamp);

        const queryParams = qs.stringify({ usertype: "D"});
        
  const response = await axios.get(`${API_BASE_URL}${urlPath}?${queryParams}`, {
            headers: {           
              "X-Signature": signature,
              "X-Timestamp": timestamp,
            },
          });
  if (response.data && response.data.plans) {
  setAllPlans(response.data.plans);


  const matchingPlans = response.data.plans.filter(
  (p) =>
  p.duration_days === duration && p.allowed_ro_count === roCount
  );


  setFilteredPlans(matchingPlans);
  } else {
  setFilteredPlans([]);
  }
  } catch (error) {
  console.error("Failed to fetch plans", error);
  setFilteredPlans([]);
  }
  };
      fetchPlans();
    }, [duration, roCount]);

    return (
      <div className="home-page">
        <Header />

        <main className="main-content">
          {/* Hero Section */}
          <section className="hero">
            <div className="hero-content">
              <div className="hero-text">
                <h1>Welcome to DriverGems</h1>
                <p>
                  At <b>DriverGems Tech Pvt Ltd</b>, we are dedicated to
                  revolutionizing the fuel industry through our subscription-based
                  app with smarter engagement, analytics, and rewards.
                </p>
                <p class="para-class"></p>
                <p class="para-class">User data is shared only with dealers for service needs — never sold.
  See <a href="https://www.drivergems.com/privacypolicy.html" target="_blank" rel="noopener noreferrer">
                Privacy Policy</a></p>
              </div>
              <div className="hero-image">
                <img src={Image1} alt="DriverGems App" />
              </div>
            </div>
          </section>

          {/* Horizontal Scrolling Image Gallery Section */}
          <section className="app-benefits-section">
    <div className="app-benefits-container">
      {/* Left side - Phone mockup */}
      <div className="phone-frame" data-aos="fade-right">
        <img className="img-in-frame" src={scrollImages[currentImageIndex]} alt="App screenshot" />
      </div>

      {/* Right side - App features and buttons */}
      <div className="app-details" data-aos="fade-left">
        

        <h2>Benefits Of Use</h2>
        <div className="benefit-list">
          <ul>
            <li>Quick data access through app</li>
            <li>Live tracking of transactions</li>
            <li>Reward points redemption</li>
            <li>Fuel and redemption history</li>
            <li>Add, delete, and modify fuel transactions</li>
          </ul>
          <ul>
            <li>Manage all subscription</li>
            <li>Register new consumer</li>
            <li>Get Reminders</li> 
            <li>Git management</li>         
          </ul>
        </div>

        <div className="store-buttons">
          <img src={googleplayimg} alt="Google Play" />
        </div>
      </div>
    </div>
  </section>



          {/* What We Offer - Image on Left, List on Right */}
          <section className="offer-section-icons">
    <h2 className="section-title">What We Offer</h2>
    <div className="offer-cards">
      <div className="offer-card">
        <img src={rewardimg} alt="Reward Points" />
        <h3>Reward Points</h3>
        <p>Earn gems for every fuel purchase and activity on the app.</p>
      </div>
      <div className="offer-card">
        <img src={otpimg} alt="OTP Redemption" />
        <h3>OTP Redemption</h3>
        <p>Redeem your points securely using OTP verification.</p>
      </div>
      <div className="offer-card">
        <img src={dashboardimg} alt="Customer Dashboard" />
        <h3>Analytics Dashboard</h3>
        <p>Track customer activity and performance in real-time.</p>
      </div>
      <div className="offer-card">
        <img src={giftimg} alt="Gift Inventory" />
        <h3>Gift Inventory</h3>
        <p>Manage gifts and rewards inventory for consumers easily.</p>
      </div>
      <div className="offer-card">
        <img src={smsimg} alt="SMS alert" />
        <h3>SMS alert</h3>
        <p>SMS alert for every transaction.</p>
      </div>
    </div>
    
  </section>


          {/* Our Plan Section */}
        {/* Our Plan Section with dropdowns */}
  <section className="our-plan" id="subscription-plans">
  <h2 className="section-title">Subscription Plans</h2>


  <div className="dropdown-row"
  style={{
    display: "flex",
    gap: "16px",
    justifyContent: "center",
    marginBottom: "32px",
  }}>
  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
  <label>Outlet Count</label>
  <select
      className="subscription-combobox" value={roCount} onChange={(e) => setRoCount(Number(e.target.value))}>
  <option value={1}>1 RO</option>
  <option value={2}>2 RO</option>
  <option value={3}>3 RO</option>
  </select>
  </div>


  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
  <label>Duration</label>
  <select
      className="subscription-combobox"
      value={duration}
  onChange={(e) => setDuration(Number(e.target.value))}
    >
  <option value={30}>1 Month</option>
  <option value={90}>3 Months</option>
  <option value={180}>6 Months</option>
  <option value={365}>1 Year</option>
  </select>
  </div>
  </div>

  {/* PRICE BOX */}
          {/* PRICE BOX */}
<div className="plans-list" data-aos="fade-up">
  {filteredPlans && filteredPlans.length > 0 ? (
    filteredPlans.map((plan) => {
      
      // ✅ Calculate Monthly Price
      const months =
        plan.duration_days === 30 ? 1 :
        plan.duration_days === 90 ? 3 :
        plan.duration_days === 180 ? 6 :
        plan.duration_days === 365 ? 12 : 1;

      const monthly = Math.floor((plan.price - plan.discount) / months) + ".00";
const percentagediscount = ((plan.discount/plan.price)*100) ;
      const isExpanded = expandedPlans.includes(plan.id);

const toggleExpand = () => {
  if (isExpanded) {
    setExpandedPlans(expandedPlans.filter(id => id !== plan.id));
  } else {
    setExpandedPlans([...expandedPlans, plan.id]);
  }
};
  
       const features = plan.features &&
  plan.features.main_features &&
  Array.isArray(plan.features.main_features)
    ? plan.features.main_features
    : [];

      return (
        <div className="plan-card" key={plan.id}>
          <h3 className="plan-title">{plan.name}</h3>

          <p className="plan-monthly">
            💰 Just <b>₹{monthly}</b> per month
          </p>
 
      {/* ✅ PRICE + DISCOUNT LOGIC */}
<div className="price-section">
  {plan.discount && plan.discount > 0 ? (
    <>
      {/* ✅ Original Price + Discount % */}
      <p >
         <span className="original-price" style={{ textDecoration: "line-through", color: "#555" }}>
          ₹{plan.price} </span>
        <span className="discount-percent" style={{color: "green", marginLeft: "8px" }}>
          (-{Math.floor(percentagediscount)}%)
        </span>
      </p>

      {/* ✅ Discount Value */}
      <p className="discount-amount" style={{ color: "red", fontWeight: "bold" }}>
        -₹{plan.discount} <span>(Exclusive discount)</span>
      </p>

      {/* ✅ Final Price */}
      <p className="final-price" style={{ color: "#007b7b", fontSize: "20px", fontWeight: "bold" }}>
        Price : ₹{(plan.price - plan.discount)}.00
      </p>
    </>
  ) : (
    /* ✅ No Discount → Normal UI */
    <p className="final-price" style={{ fontSize: "20px", fontWeight: "bold" }}>
      Price: ₹{plan.price}
    </p>
  )}
</div>


          <p className="plan-duration">
            Duration: {
              plan.duration_days === 30 ? "1 Month" :
              plan.duration_days === 90 ? "3 Months" :
              plan.duration_days === 180 ? "6 Months" :
              plan.duration_days === 365 ? "1 Year" :
              `${plan.duration_days} days`
            }
          </p>

{/* ✅ If NOT expanded, show button here */}
  {!isExpanded && (
    <button
      className="toggle-features-btn"
       onClick={toggleExpand}
    >
      Tap to expand
    </button>
  )}
 

{/* ✅ Expanded Section */}
{isExpanded && (
  <>
    {/* ✅ Features Label */}
    <h4 className="features-label">Features:</h4>

    {/* ✅ Bullet Points */}
    <ul className="feature-list-expanded">
      {features.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>

    {/* ✅ Hide button at bottom */}
    <button
      className="toggle-features-btn"
      onClick={toggleExpand}
      style={{ marginTop: "20px" }}
    >
      Hide
    </button>
  </>
)}

        </div>
      );
    })
  ) : (
    <h3>No plans found for this selection</h3>
  )}
</div>

  </section>

        </main>

        <WhatsAppButton />
        <Footer />
      </div>
    );
  };
  export default HomePage;